import styled from 'styled-components';
import {
  ParentInfoWrapper,
  SortableParentWidgetRenderWrapper,
  TotalWrapper,
} from './SortableParentWidgetRender.styled.tsx';

export const ContentWrapper = styled.div`
  position: relative;
  // altezza per il container per avere lo spazio minimo
  // per mostrare i pulsanti di configurazione del widget
  min-height: 44px;
  // fix per rimuovere spazio verticale in compilazione
  // quando il campo (widget) è nascosto
  &.fillable-widget-wrapper {
    min-height: 0px;
  }

  &:hover {
    // all'hover evidenziamo la barra del container
    > ${TotalWrapper} {
      > ${SortableParentWidgetRenderWrapper} {
        border-color: ${props => props.theme.colorPrimaryBg};
        > ${ParentInfoWrapper} {
          background-color: ${props => props.theme.colorPrimaryBg};
        }
      }
    }
  }
`;

export const WidgetContainerWrapper = styled.div`
  position: relative;
  border: none;
`;
